import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { RequestResponse } from '../intefaces/requestResponse';
import { OrderManagementFrame } from '../intefaces/orderManagementFrame';
import { Order } from '../intefaces/order';

@Injectable({
  providedIn: 'root'
})
export class OrderManagementService extends BaseService {

  constructor(protected http: HttpClient) {
    super();
  }

  public getOrders(order: OrderManagementFrame) {
    return this.http.post<RequestResponse>(this.getUrl('orderManagement'), order);
  }

  public editOrder(order: Order) {
    return this.http.post<RequestResponse>(this.getUrl('editOrder'), order);
  }

  public editInvoice(invoice) {
    return this.http.post<RequestResponse>(this.setUrl('admin/updateInvoice'), invoice);
  }

  public getInvoices(invoice) {
    return this.http.post<RequestResponse>(this.setUrl('admin/invoices'), invoice);
  }

  public uploadManualInvoice(payload: any) {
    return this.http.post<RequestResponse>(this.setUrl('admin/manualInvoiceUpload'), payload);
  }

  public deleteManualInvoice(orderId: number) {
    return this.http.post<RequestResponse>(this.setUrl('admin/manualInvoiceDelete'), { order_id: orderId });
  }

  public getSettingsInvoice() {
    return this.http.post<RequestResponse>(this.setUrl('admin/getSettingsInvoice'), {});
  }

  public editSettingsInvoice(settings) {
    return this.http.post<RequestResponse>(this.setUrl('admin/editSettingsInvoice'), settings);
  }

}

